var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 38.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(923 509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    transform: "translate(8.184 10.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    transform: "translate(0.199 0.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    transform: "translate(0 5.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    transform: "translate(0.105 5.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    className: "st2",
    d: "M-922.9-503.3c1.2-0.8,2.3-1.9,3.3-3c0.5-0.5,1-1,1.5-1.6c0.6-0.5,1.1-1.1,1.5-1.8                   c0.2-0.4,0-1-0.4-1.2c-0.3-0.1-0.6-0.1-0.8,0c-0.6,0.5-1.2,1-1.7,1.6c-0.5,0.5-1,1-1.5,1.6c-1.1,1-2.1,2.1-2.9,3.4                   c-0.2,0.4-0.1,0.8,0.3,1C-923.4-503.2-923.1-503.2-922.9-503.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    className: "st2",
    d: "M-923.9-510.2c0.7,1,1.6,1.9,2.6,2.7c0.9,0.9,1.9,1.8,2.9,2.6c0.4,0.3,0.9,0.3,1.2-0.1                   c0.3-0.3,0.3-0.8,0-1.2c-0.9-0.9-2-1.8-3-2.7c-0.9-0.9-1.9-1.6-3.1-2.1c-0.3-0.1-0.6,0.1-0.7,0.4                   C-924-510.5-924-510.3-923.9-510.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    transform: "translate(4.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    transform: "translate(0 0.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    className: "st2",
    d: "M-923.9-509.9c0.8,1.2,1.9,2.3,3,3.3c0.5,0.5,1,1,1.6,1.5c0.5,0.6,1.1,1.1,1.8,1.5                   c0.4,0.2,1,0,1.2-0.4c0.1-0.3,0.1-0.6,0-0.8c-0.5-0.6-1-1.2-1.6-1.7c-0.5-0.5-1-1-1.6-1.5c-1-1.1-2.1-2.1-3.4-2.9                   c-0.4-0.2-0.8-0.1-1,0.3C-924-510.4-924-510.1-923.9-509.9L-923.9-509.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    transform: "translate(6.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    className: "st2",
    d: "M-918.5-510.9c-1,0.7-1.9,1.6-2.7,2.6c-0.9,0.9-1.8,1.9-2.6,2.9                   c-0.3,0.4-0.3,0.9,0.1,1.2c0.3,0.3,0.8,0.3,1.2,0c0.9-0.9,1.8-2,2.7-3c0.9-0.9,1.6-1.9,2.1-3.1c0.1-0.3-0.1-0.6-0.4-0.7                   C-918.3-511-918.4-511-918.5-510.9L-918.5-510.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    transform: "translate(4.291 3.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    transform: "translate(9.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    className: "st2",
    d: "M-917.6-510.9c-1.2,0.8-2.3,1.9-3.3,3c-0.5,0.5-1,1-1.5,1.6c-0.6,0.5-1.1,1.1-1.5,1.8                   c-0.2,0.4,0,1,0.4,1.2c0.3,0.1,0.6,0.1,0.8,0c0.6-0.5,1.2-1,1.7-1.6c0.5-0.5,1-1,1.5-1.6c1.1-1,2.1-2.1,2.9-3.4                   c0.2-0.4,0.1-0.8-0.3-1C-917.1-511-917.4-511-917.6-510.9L-917.6-510.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    transform: "translate(0.502 6.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    className: "st2",
    d: "M-917-505.5c-0.7-1-1.6-1.9-2.6-2.7c-0.9-0.9-1.9-1.8-2.9-2.6c-0.4-0.3-0.9-0.3-1.2,0.1                   c-0.3,0.3-0.3,0.8,0,1.2c0.9,0.9,2,1.8,3,2.7c0.9,0.9,1.9,1.6,3.1,2.1c0.3,0.1,0.6-0.1,0.7-0.4                   C-916.9-505.3-916.9-505.4-917-505.5L-917-505.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    transform: "translate(0 10.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    transform: "translate(5.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    className: "st2",
    d: "M-916.3-504.6c-0.8-1.2-1.9-2.3-3-3.3c-0.5-0.5-1-1-1.6-1.5c-0.5-0.6-1.1-1.1-1.8-1.5                   c-0.4-0.2-1,0-1.2,0.4c-0.1,0.3-0.1,0.6,0,0.8c0.5,0.6,1,1.2,1.6,1.7c0.5,0.5,1,1,1.6,1.5c1,1.1,2.1,2.1,3.4,2.9                   c0.4,0.2,0.8,0.1,1-0.3C-916.2-504.1-916.2-504.4-916.3-504.6L-916.3-504.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    transform: "translate(0 0.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    className: "st2",
    d: "M-923.2-504c1-0.7,1.9-1.6,2.7-2.6c0.9-0.9,1.8-1.9,2.6-2.9c0.3-0.4,0.3-0.9-0.1-1.2                   c-0.3-0.3-0.8-0.3-1.2,0c-0.9,0.9-1.8,2-2.7,3c-0.9,0.9-1.6,1.9-2.1,3.1c-0.1,0.3,0.1,0.6,0.4,0.7                   C-923.4-503.9-923.3-503.9-923.2-504L-923.2-504z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    transform: "translate(0 0.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    className: "st2",
    d: "M-922.7-504.8c0.8-0.7,1.5-1.4,2.2-2.2c0.8-0.7,1.5-1.5,2.1-2.4c0.6-0.9-0.7-2-1.5-1.4             c-0.8,0.7-1.6,1.4-2.2,2.3c-0.7,0.8-1.4,1.6-1.9,2.6C-924.2-505.2-923.5-504.2-922.7-504.8L-922.7-504.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    transform: "translate(0.039 17.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    className: "st2",
    d: "M-924-510.2c0.3,0.8,0.9,1.4,1.6,1.9c0.7,0.6,1.4,1.2,2.2,1.7c1,0.7,2.3-0.7,1.4-1.4             c-0.7-0.5-1.5-1.1-2.2-1.7c-0.6-0.6-1.4-1.1-2.2-1.3c-0.4,0-0.7,0.2-0.7,0.6C-924-510.3-924-510.2-924-510.2L-924-510.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    transform: "translate(16.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    className: "st2",
    d: "M-923.9-510c0.5,0.7,1.1,1.3,1.8,1.8c0.7,0.5,1.4,1.1,2,1.6c0.9,0.7,2.3-0.7,1.3-1.4             c-0.7-0.6-1.5-1.1-2.2-1.7c-0.6-0.6-1.4-1-2.2-1.3c-0.4-0.1-0.7,0.2-0.8,0.5C-924-510.3-924-510.1-923.9-510L-923.9-510z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    transform: "translate(16.215 15.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    className: "st2",
    d: "M-923.2-506.6L-923.2-506.6c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,1,1,1c0,0,0,0,0.1,0           c0.7,0,1.2-0.8,1.6-1.3c0.5-0.6,1-1.2,1.6-1.8c0.6-0.6,1.1-1.3,1.5-2c0.2-0.8-0.7-1.3-1.3-0.9c-0.8,0.6-1.5,1.4-2.1,2.2           c-0.3,0.4-0.6,0.7-0.9,1.1c-0.2,0.3-0.6,0.9-0.9,1.1c0.2,0,0.5-0.1,0.7-0.1c0.1,0.1,0.3,0.3,0.4,0.4           C-922.6-506.4-922.9-506.6-923.2-506.6L-923.2-506.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.907c20b117f4c918fe80ba6761c74739.svg";
export { ForwardRef as ReactComponent };